import { useEffect, createElement } from 'react';
import { useRouter } from 'next/router';
import { helpPages } from 'pro/config/help';
import { trackPageView } from 'base/utils/tracker';
import type { GetServerSidePropsContext } from 'next';
import { useStoreState } from 'base/store';

const HelpPage: Globals.NextPage = () => {
    const { query } = useRouter();
    const { lang } = useStoreState('rootStore')
    const code = query.code as string;
    const page = helpPages[code];

    useEffect(() => {
        trackPageView()
    }, [code]);

    return createElement(page.content[lang] || page.content.en);
}

HelpPage.pageConf = {
    pageCode: 'help'
};

export default HelpPage;

export async function getServerSideProps({ params }: GetServerSidePropsContext) {
    const code = params?.code as string;
    if (!code || !helpPages[code]) {
        return {
            notFound: true,
        }
    }
    return {
        props: {
            bodyClassName: `g-body-${code}`
        }
    }
}
